import * as React from "react";
const PersonSVG = () => (
  <svg viewBox="0 0 86 102" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx={42.6644} cy={25.9695} r={25.0838} fill="white" fillOpacity={0.17} />
    <path
      d="M85.0129 101.405H0.315918C0.315918 78.017 19.276 59.0569 42.6644 59.0569C66.0529 59.0569 85.0129 78.017 85.0129 101.405Z"
      fill="white"
      fillOpacity={0.17}
    />
  </svg>
);
export default PersonSVG;
